import { ActionButtonInverted } from 'components/button/button.styled'
import { useNavigate } from 'react-router-dom'

import { Container, NameDisplay } from './currentPartner.style'

interface Props {
    partnerName: string
    backButton?: boolean
}

export const CurrentPartner = ({ partnerName, backButton = true }: Props) => {
    const navigate = useNavigate()

    const handleBackClick = () => {
        navigate('/admin/szervezetek')
    }

    return (
        <Container>
            {backButton && <ActionButtonInverted icon="pi pi-arrow-left" label="Vissza" onClick={handleBackClick} />}
            <NameDisplay>{partnerName}</NameDisplay>
        </Container>
    )
}
